import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "manage-header"
};
var _hoisted_2 = {
  class: "manage-header-content"
};
var _hoisted_3 = {
  key: 1,
  class: "main"
};
var _hoisted_4 = {
  class: "user-info space-top"
};
var _hoisted_5 = {
  class: "user-info-header-left"
};
var _hoisted_6 = {
  class: "user-info-header-right"
};
var _hoisted_7 = {
  class: "span"
};
var _hoisted_8 = {
  class: "user-info-list"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  class: "user-info-list-item-info"
};
var _hoisted_12 = {
  class: "user-info-list-item"
};
var _hoisted_13 = {
  key: 0,
  class: "user-info-list-item"
};
var _hoisted_14 = {
  class: "aside"
};
var _hoisted_15 = {
  class: "label"
};
var _hoisted_16 = {
  class: "article"
};
var _hoisted_17 = {
  class: "footer list space-top"
};
var _hoisted_18 = {
  key: 0,
  class: "del-dialog-title"
};
var _hoisted_19 = {
  key: 1,
  class: "del-dialog-title"
};
import { ref, computed, watchEffect, onMounted, nextTick } from '../../../adapter-vue';
import TUIChatEngine, { TUITranslateService, TUIGroupService, TUIFriendService, TUIStore, StoreName, TUIConversationService, TUIUserService } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal, outsideClick } from '@tencentcloud/universal-api';
import MaskLayer from '../../common/MaskLayer/index.vue';
import Dialog from '../../common/Dialog/index.vue';
import Transfer from '../../common/Transfer/index.vue';
import ManageName from './manage-name.vue';
import ManageNotification from './manage-notification.vue';
import ManageMember from './manage-member.vue';
import ManageProfile from './manage-profile.vue';
import ManageAdmin from './manage-admin.vue';
import Icon from '../../common/Icon.vue';
import backSVG from '../../../assets/icon/back.svg';
import rightIcon from '../../../assets/icon/right-icon.svg';
import { Toast, TOAST_TYPE } from '../../common/Toast/index';
import { isPC, isUniFrameWork } from '../../../utils/env';
import Server from '../server';
import { enableSampleTaskStatus } from '../../../utils/enableSampleTaskStatus';
import { get_user_list } from '@/api/apis';
import { ElMessageBox } from 'element-plus';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    groupID: {
      type: String,
      default: ''
    },
    groupCurrentTab: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    var TUIGroupServer = Server.getInstance();
    var TUIConstants = TUIGroupServer.constants;
    var props = __props;
    var visible = ref(false);
    var manageRef = ref(undefined);
    var currentTab = ref('');
    var editLableName = ref('');
    var transferType = ref('');
    var mask = ref(false);
    var currentGroupID = ref('');
    var userInfo = ref({
      list: []
    });
    var currentMember = ref({});
    var typeName = ref({
      [TUIChatEngine.TYPES.GRP_WORK]: '好友工作群',
      [TUIChatEngine.TYPES.GRP_PUBLIC]: '陌生人社交群',
      [TUIChatEngine.TYPES.GRP_MEETING]: '临时会议群',
      [TUIChatEngine.TYPES.GRP_AVCHATROOM]: '直播群',
      [TUIChatEngine.TYPES.GRP_COMMUNITY]: '社群',
      [TUIChatEngine.TYPES.JOIN_OPTIONS_FREE_ACCESS]: '自由加入',
      [TUIChatEngine.TYPES.JOIN_OPTIONS_NEED_PERMISSION]: '需要验证',
      [TUIChatEngine.TYPES.JOIN_OPTIONS_DISABLE_APPLY]: '禁止加群'
    });
    var member = ref({
      admin: [],
      member: [],
      muteMember: []
    });
    var transferList = ref([]);
    var transferTitle = ref('');
    var isSearch = ref(true);
    var isRadio = ref(false);
    var selectedList = ref([]);
    var delDialogShow = ref(false);
    var groupMemberList = ref([]);
    var deletedUserList = ref([]);
    var _currentGroup = ref();
    var currentSelfRole = ref('');
    var groupIDValue = ref('');
    onMounted(() => {
      nextTick(() => {
        if (manageRef.value) {
          outsideClick.listen({
            domRefs: manageRef.value,
            handler: handleCompleteManage
          });
        }
      });
    });
    TUIStore.watch(StoreName.GRP, {
      currentGroup: group => {
        if (group) {
          var _currentGroup$value;
          _currentGroup.value = group;
          currentSelfRole.value = (_currentGroup$value = _currentGroup.value) === null || _currentGroup$value === void 0 || (_currentGroup$value = _currentGroup$value.selfInfo) === null || _currentGroup$value === void 0 ? void 0 : _currentGroup$value.role;
        }
      },
      currentGroupMemberList: memberList => {
        groupMemberList.value = memberList;
        member.value = {
          admin: [],
          member: [],
          muteMember: []
        };
        Array.from(memberList).map(item => {
          switch (item === null || item === void 0 ? void 0 : item.role) {
            case TUIChatEngine.TYPES.GRP_MBR_ROLE_ADMIN:
              member.value.admin.push(item);
              break;
            case TUIChatEngine.TYPES.GRP_MBR_ROLE_MEMBER:
              member.value.member.push(item);
              break;
            default:
              break;
          }
          return item;
        });
        var time = new Date().getTime();
        member.value.muteMember = Array.from(memberList).filter(item => (item === null || item === void 0 ? void 0 : item.muteUntil) * 1000 - time > 0);
      }
    });
    TUIStore.watch(StoreName.CONV, {
      currentConversation: conversation => {
        var _conversation$groupPr;
        groupIDValue.value = conversation === null || conversation === void 0 || (_conversation$groupPr = conversation.groupProfile) === null || _conversation$groupPr === void 0 ? void 0 : _conversation$groupPr.groupID;
      }
    });
    watchEffect(() => {
      var params = TUIGroupServer.getOnCallParams(TUIConstants.TUIGroup.SERVICE.METHOD.OPEN_GROUP_MANAGEMENT);
      currentGroupID.value = params.groupID || groupIDValue.value;
      currentTab.value = props.groupCurrentTab;
    });
    var TabName = computed(() => {
      var name = '';
      switch (currentTab.value) {
        case 'notification':
          name = '群公告';
          break;
        case 'member':
          name = '群成员';
          break;
        case 'profile':
          name = '群成员';
          break;
        default:
          name = '群管理';
          break;
      }
      return name;
    });
    var isAuthor = computed(() => {
      var _currentGroup$value2;
      // 判断是否是群主/管理员
      var userRole = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value2 = _currentGroup.value) === null || _currentGroup$value2 === void 0 || (_currentGroup$value2 = _currentGroup$value2.selfInfo) === null || _currentGroup$value2 === void 0 ? void 0 : _currentGroup$value2.role;
      var isOwner = userRole === TUIChatEngine.TYPES.GRP_MBR_ROLE_OWNER;
      var isAdmin = userRole === TUIChatEngine.TYPES.GRP_MBR_ROLE_ADMIN;
      return isOwner || isAdmin;
    });
    var isAdmin = computed(() => {
      var _currentGroup$value3, _currentGroup$value4;
      var groupType = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value3 = _currentGroup.value) === null || _currentGroup$value3 === void 0 ? void 0 : _currentGroup$value3.type;
      var userRole = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value4 = _currentGroup.value) === null || _currentGroup$value4 === void 0 || (_currentGroup$value4 = _currentGroup$value4.selfInfo) === null || _currentGroup$value4 === void 0 ? void 0 : _currentGroup$value4.role;
      var isOwner = userRole === TUIChatEngine.TYPES.GRP_MBR_ROLE_OWNER;
      var isWork = groupType === TUIChatEngine.TYPES.GRP_WORK;
      var isAVChatRoom = groupType === TUIChatEngine.TYPES.GRP_AVCHATROOM;
      if (!isWork && !isAVChatRoom && isOwner) {
        return true;
      }
      return false;
    });
    var isSetMuteTime = computed(() => {
      var _currentGroup$value5;
      var groupType = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value5 = _currentGroup.value) === null || _currentGroup$value5 === void 0 ? void 0 : _currentGroup$value5.type;
      var isWork = groupType === TUIChatEngine.TYPES.GRP_WORK;
      if (isWork || !isAuthor.value) {
        return false;
      }
      return true;
    });
    var canDelMember = computed(() => {
      var _currentGroup$value6;
      var groupType = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value6 = _currentGroup.value) === null || _currentGroup$value6 === void 0 ? void 0 : _currentGroup$value6.type;
      var isAVChatRoom = groupType === TUIChatEngine.TYPES.GRP_AVCHATROOM;
      if (isAVChatRoom) {
        return false;
      }
      return true;
    });
    var updateProfile = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (newGroupProfile) {
        var {
          key,
          value
        } = newGroupProfile;
        var options = {
          groupID: _currentGroup.value.groupID,
          [key]: value
        };
        TUIGroupService.updateGroupProfile(options).then(res => {
          _currentGroup.value = res.data.group;
          editLableName.value = '';
        }).catch(error => {
          Toast({
            message: error === null || error === void 0 ? void 0 : error.message,
            type: TOAST_TYPE.ERROR
          });
        });
      });
      return function updateProfile(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var setCurrentTab = tabName => {
      currentTab.value = tabName;
      editLableName.value = '';
      if (currentTab.value === 'member') {
        transferType.value = 'remove';
      }
      if (!currentTab.value) {
        transferType.value = '';
      }
    };
    var cancel = () => {
      toggleMask();
    };
    var toggleMask = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (type) {
        var _transferList$value;
        selectedList.value = [];
        switch (type) {
          case 'add':
            isRadio.value = false;
            // transferList.value = await friendList();
            // console.log("transferList.value->",transferList.value)
            transferTitle.value = '添加成员';
            break;
          case 'remove':
            isRadio.value = false;
            transferList.value = groupMemberList.value.filter(item => {
              var _currentGroup$value7;
              return item.userID !== (_currentGroup === null || _currentGroup === void 0 || (_currentGroup$value7 = _currentGroup.value) === null || _currentGroup$value7 === void 0 || (_currentGroup$value7 = _currentGroup$value7.selfInfo) === null || _currentGroup$value7 === void 0 ? void 0 : _currentGroup$value7.userID);
            });
            transferTitle.value = '删除成员';
            break;
          case 'addAdmin':
            isRadio.value = true;
            transferList.value = member.value.member;
            transferTitle.value = '新增管理员';
            break;
          case 'removeAdmin':
            isRadio.value = true;
            transferList.value = member.value.admin;
            transferTitle.value = '移除管理员';
            break;
          case 'changeOwner':
            isRadio.value = true;
            transferList.value = [...member.value.admin, ...member.value.member];
            transferTitle.value = '转让群组';
            break;
          case 'addMute':
            isRadio.value = true;
            transferList.value = member.value.member;
            if (_currentGroup.value.selfInfo.role === 'Owner') {
              transferList.value = [...member.value.admin, ...member.value.member];
            }
            transferList.value = transferList === null || transferList === void 0 || (_transferList$value = transferList.value) === null || _transferList$value === void 0 ? void 0 : _transferList$value.filter(item => {
              var _member$value;
              return (member === null || member === void 0 || (_member$value = member.value) === null || _member$value === void 0 || (_member$value = _member$value.muteMember) === null || _member$value === void 0 ? void 0 : _member$value.indexOf(item)) < 0;
            });
            transferTitle.value = '新增禁言用户';
            break;
          case 'removeMute':
            isRadio.value = true;
            transferList.value = member.value.muteMember;
            transferTitle.value = '移除禁言用户';
            break;
          default:
            break;
        }
        type && (transferType.value = type);
        mask.value = !mask.value;
      });
      return function toggleMask(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var friendList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* () {
        var imResponse = yield TUIFriendService.getFriendList();
        var friendList = imResponse.data.map(item => item === null || item === void 0 ? void 0 : item.profile);
        return friendList.filter(item => !userInfo.value.list.some(infoItem => infoItem.userID === item.userID));
      });
      return function friendList() {
        return _ref3.apply(this, arguments);
      };
    }();
    var canIDissmissGroup = computed(() => {
      var _currentGroup$value8, _currentGroup$value9;
      var userRole = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value8 = _currentGroup.value) === null || _currentGroup$value8 === void 0 || (_currentGroup$value8 = _currentGroup$value8.selfInfo) === null || _currentGroup$value8 === void 0 ? void 0 : _currentGroup$value8.role;
      var groupType = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value9 = _currentGroup.value) === null || _currentGroup$value9 === void 0 ? void 0 : _currentGroup$value9.type;
      return userRole === TUIChatEngine.TYPES.GRP_MBR_ROLE_OWNER && groupType !== TUIChatEngine.TYPES.GRP_WORK;
    });
    var isShowAddMember = computed(() => {
      var _currentGroup$value10;
      var groupType = _currentGroup === null || _currentGroup === void 0 || (_currentGroup$value10 = _currentGroup.value) === null || _currentGroup$value10 === void 0 ? void 0 : _currentGroup$value10.type;
      return groupType === TUIChatEngine.TYPES.GRP_WORK;
    });
    var showUserNum = computed(() => {
      var _currentGroup$value11;
      var num = 3;
      if (!isShowAddMember.value) {
        num += 1;
      }
      if ((_currentGroup === null || _currentGroup === void 0 || (_currentGroup$value11 = _currentGroup.value) === null || _currentGroup$value11 === void 0 || (_currentGroup$value11 = _currentGroup$value11.selfInfo) === null || _currentGroup$value11 === void 0 ? void 0 : _currentGroup$value11.role) !== 'Owner') {
        num += 1;
      }
      return num;
    });
    var getMember = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(function* (type) {
        var groupID = currentGroupID.value;
        var options = {
          groupID,
          count: 100,
          offset: type && type === 'more' ? userInfo.value.list.length : 0
        };
        yield TUIGroupService.getGroupMemberList(options).then(res => {
          if (type && type === 'more') {
            userInfo.value.list = [...userInfo.value.list, ...res.data.memberList];
          } else {
            userInfo.value.list = res.data.memberList;
          }
        });
      });
      return function getMember(_x3) {
        return _ref4.apply(this, arguments);
      };
    }();
    var handleMemberProfileShow = user => {
      currentMember.value = user;
      setCurrentTab('profile');
    };
    var submit = userList => {
      // 进行成员移除等等相关操作
      if (transferType.value === 'remove') {
        deletedUserList.value = userList;
        delDialogShow.value = !delDialogShow.value;
      } else {
        handleManage(userList, transferType.value);
      }
      mask.value = false;
    };
    var dismissGroup = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(function* (group) {
        ElMessageBox.confirm('确定解散群组？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          draggable: false
        }).then(/*#__PURE__*/_asyncToGenerator(function* () {
          // 解散群组
          yield TUIGroupService.dismissGroup(group.groupID);
          enableSampleTaskStatus('dismissGroup');
          Toast({
            message: TUITranslateService.t('TUIGroup.群组解散成功'),
            type: TOAST_TYPE.SUCCESS
          });
          clearGroupInfo();
        })).catch(() => {
          Toast({
            message: TUITranslateService.t('component.已取消'),
            type: TOAST_TYPE.NORMAL
          });
        });
      });
      return function dismissGroup(_x4) {
        return _ref5.apply(this, arguments);
      };
    }();
    var clearGroupInfo = () => {
      if (isUniFrameWork) {
        TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.switchTab({
          url: '/TUIKit/components/TUIConversation/index'
        });
      } else {
        handleCompleteManage();
        // 回到chat default 页
        TUIConversationService.switchConversation();
      }
    };
    var setAllMuteTime = value => {
      // 设置全体禁言时间
      updateProfile({
        key: 'muteAllMembers',
        value
      });
      if (value) {
        enableSampleTaskStatus('muteGroup');
        Toast({
          message: TUITranslateService.t('TUIGroup.禁言设置成功'),
          type: TOAST_TYPE.SUCCESS
        });
      } else {
        Toast({
          message: TUITranslateService.t('TUIGroup.取消禁言成功'),
          type: TOAST_TYPE.SUCCESS
        });
      }
    };
    // 获取百林客的用户数据
    var getblkUserList = val => {
      var obj = {
        page: 1,
        limit: 1000,
        key_word: val
      };
      get_user_list(obj).then(res_blk => {
        console.log("获取的用户列表", res_blk);
        var member = res_blk.data.data;
        var userids = member.map(x => x.name);
        var can_member = [];
        TUIUserService.getUserProfile({
          userIDList: userids
        }).then(res_ => {
          console.log("2er--->", res_);
          can_member = JSON.parse(JSON.stringify(res_.data));
          console.log("搜索到的用户列表中已登录IM的人员--->", can_member);
          member = member.filter(x => {
            var index_ = can_member.findIndex(m => m.userID == x.name);
            if (index_ != -1) {
              return x;
            }
          });
          member.forEach(x => {
            x.nick = x.name;
            x.userID = x.name;
          });
          console.log("can_member->", can_member, 'member->', member);
          transferList.value = JSON.parse(JSON.stringify(member));
        });
      });
    };
    var handleSearchMember = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(function* (value) {
        var imResponse = {};
        var imMemberResponse = {};
        var options = {
          groupID: currentGroupID.value,
          userIDList: [value]
        };
        switch (transferType.value) {
          case 'add':
            try {
              // imMemberResponse = await TUIGroupService.getGroupMemberProfile(options)
              // transferList.value = transferList.value.filter(
              //   (item: any) => item.userID !== imResponse.data[0]?.userID
              // )
              // console.log("imMemberResponse->",imMemberResponse)
              // transferList.value = [...transferList.value, ...imResponse.data]
              // if (imMemberResponse?.data?.memberList.length > 0) {
              //   transferList.value = transferList.value.map((item: any) => {
              //     if (item.userID === imMemberResponse?.data?.memberList[0].userID) {
              //       item.isDisabled = true
              //     }
              //     return item
              //   })
              // }
              console.log("搜索啦");
              getblkUserList(value);
            } catch (error) {
              var message = TUITranslateService.t('TUIGroup.该用户不存在');
              Toast({
                message,
                type: TOAST_TYPE.ERROR
              });
            }
            break;
          case 'remove':
            try {
              var _imResponse2;
              imResponse = yield TUIGroupService.getGroupMemberProfile(options);
              if (imResponse.data.memberList.length === 0) {
                var _message = TUITranslateService.t('TUIGroup.该用户不在群组内');
                Toast({
                  message: _message,
                  type: TOAST_TYPE.ERROR
                });
              }
              transferList.value = transferList.value.filter(item => {
                var _imResponse;
                return item.userID !== ((_imResponse = imResponse) === null || _imResponse === void 0 || (_imResponse = _imResponse.data) === null || _imResponse === void 0 || (_imResponse = _imResponse.memberList[0]) === null || _imResponse === void 0 ? void 0 : _imResponse.userID);
              });
              if ((_imResponse2 = imResponse) !== null && _imResponse2 !== void 0 && (_imResponse2 = _imResponse2.data) !== null && _imResponse2 !== void 0 && _imResponse2.memberList.length) {
                transferList.value = [...transferList.value, ...imResponse.data.memberList];
              }
            } catch (error) {
              var _message2 = TUITranslateService.t('TUIGroup.该用户不存在');
              Toast({
                message: _message2,
                type: TOAST_TYPE.ERROR
              });
            }
            break;
          default:
            break;
        }
      });
      return function handleSearchMember(_x5) {
        return _ref7.apply(this, arguments);
      };
    }();
    var handleManage = (userList, type) => {
      var userIDList = [];
      userList.map(item => {
        userIDList.push(item.userID);
        return item;
      });
      switch (type) {
        case 'add':
          addMember(userIDList);
          break;
        case 'remove':
          deleteGroupMember(userIDList);
          break;
        case 'addAdmin':
          handleAdmin(userList[0]);
          break;
        case 'removeAdmin':
          handleAdmin(userList[0]);
          break;
        case 'changeOwner':
          changeOwner(userIDList[0]);
          break;
        case 'addMute':
          setMemberMuteTime(userIDList[0], 'add');
          break;
        case 'removeMute':
          setMemberMuteTime(userIDList[0], 'remove');
          break;
        default:
          break;
      }
    };
    var addMember = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(function* (userIDList) {
        var options = {
          groupID: currentGroupID.value,
          userIDList
        };
        yield TUIGroupService.addGroupMember(options);
      });
      return function addMember(_x6) {
        return _ref8.apply(this, arguments);
      };
    }();
    var changeOwner = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(function* (userID) {
        var options = {
          groupID: currentGroupID.value,
          newOwnerID: userID
        };
        var imResponse = yield TUIGroupService.changeGroupOwner(options);
        _currentGroup.value = {};
        _currentGroup.value = imResponse.data.group;
      });
      return function changeOwner(_x7) {
        return _ref9.apply(this, arguments);
      };
    }();
    var setMemberMuteTime = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator(function* (userID, type) {
        var options = {
          groupID: currentGroupID.value,
          userID,
          muteTime: type === 'add' ? 60 * 60 * 24 * 30 : 0
        };
        yield TUIGroupService.setGroupMemberMuteTime(options);
      });
      return function setMemberMuteTime(_x8, _x9) {
        return _ref10.apply(this, arguments);
      };
    }();
    var handleAdmin = /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator(function* (user) {
        var role = '';
        switch (user.role) {
          case TUIChatEngine.TYPES.GRP_MBR_ROLE_ADMIN:
            role = TUIChatEngine.TYPES.GRP_MBR_ROLE_MEMBER;
            break;
          case TUIChatEngine.TYPES.GRP_MBR_ROLE_MEMBER:
            role = TUIChatEngine.TYPES.GRP_MBR_ROLE_ADMIN;
            break;
        }
        var options = {
          groupID: currentGroupID.value,
          userID: user.userID,
          role
        };
        yield TUIGroupService.setGroupMemberRole(options);
      });
      return function handleAdmin(_x10) {
        return _ref11.apply(this, arguments);
      };
    }();
    var deleteGroupMember = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator(function* (userIDList) {
        var options = {
          groupID: currentGroupID.value,
          userIDList,
          reason: ''
        };
        yield TUIGroupService.deleteGroupMember(options);
      });
      return function deleteGroupMember(_x11) {
        return _ref12.apply(this, arguments);
      };
    }();
    var quitGroup = /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator(function* (group) {
        ElMessageBox.confirm('确定退出群组？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          draggable: false
        }).then(/*#__PURE__*/_asyncToGenerator(function* () {
          yield TUIGroupService.quitGroup(group.groupID);
          clearGroupInfo();
        })).catch(() => {
          Toast({
            message: TUITranslateService.t('component.已取消'),
            type: TOAST_TYPE.NORMAL
          });
        });
      });
      return function quitGroup(_x12) {
        return _ref13.apply(this, arguments);
      };
    }();
    var back = () => {
      if (currentTab.value) {
        setCurrentTab('');
      } else {
        handleCompleteManage();
      }
    };
    var handleCompleteManage = () => {
      TUIStore.update(StoreName.GRP, 'isShowManageComponent', false);
      var callback = TUIGroupServer.getOnCallCallback(TUIConstants.TUIGroup.SERVICE.METHOD.OPEN_GROUP_MANAGEMENT);
      callback && callback();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "manageRef",
        ref: manageRef,
        class: "manage"
      }, [!_unref(isUniFrameWork) || _unref(currentTab) === 'admin' ? (_openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("div", {
        onClick: back
      }, [_createVNode(Icon, {
        file: _unref(backSVG)
      }, null, 8, ["file"])]), _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.".concat(_unref(TabName)))), 1)])) : _createCommentVNode("", true), !_unref(currentTab) || _unref(isUniFrameWork) && _unref(currentTab) != 'admin' ? (_openBlock(), _createElementBlock("main", _hoisted_3, [_createVNode(ManageName, {
        class: "space-top",
        isAuthor: _unref(isAuthor),
        data: _unref(_currentGroup),
        onUpdate: updateProfile
      }, null, 8, ["isAuthor", "data"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("header", {
        class: "user-info-header",
        onClick: _cache[0] || (_cache[0] = $event => setCurrentTab('member'))
      }, [_createElementVNode("label", _hoisted_5, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u6210\u5458")), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_unref(_currentGroup).memberCount || _unref(groupMemberList).length) + " " + _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u4EBA")), 1), _createVNode(Icon, {
        file: _unref(rightIcon)
      }, null, 8, ["file"])])]), _createElementVNode("ol", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupMemberList).slice(0, _unref(showUserNum)), (item, index) => {
        return _openBlock(), _createElementBlock("dl", {
          key: index,
          class: "user-info-list-item"
        }, [_createElementVNode("dt", {
          class: "user-info-list-item-main",
          onClick: $event => handleMemberProfileShow(item)
        }, [_createElementVNode("img", {
          class: "avatar",
          src: item.avatar || 'https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png',
          onerror: "this.onerror=null;this.src='https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png'"
        }, null, 8, _hoisted_10)], 8, _hoisted_9), _createElementVNode("dd", _hoisted_11, _toDisplayString(item.nick || item.userID), 1)]);
      }), 128)), _createElementVNode("dl", _hoisted_12, [_createElementVNode("dt", {
        class: "avatar",
        onClick: _cache[1] || (_cache[1] = $event => toggleMask('add'))
      }, " + ")]), _unref(currentSelfRole) === 'Owner' ? (_openBlock(), _createElementBlock("dl", _hoisted_13, [_createElementVNode("dt", {
        class: "avatar",
        onClick: _cache[2] || (_cache[2] = $event => toggleMask('remove'))
      }, " - ")])) : _createCommentVNode("", true)])]), _createElementVNode("ul", {
        class: "content list space-top",
        onClick: _cache[4] || (_cache[4] = $event => editLableName.value = '')
      }, [_createElementVNode("li", {
        class: "list-item",
        onClick: _cache[3] || (_cache[3] = $event => setCurrentTab('notification'))
      }, [_createElementVNode("aside", _hoisted_14, [_createElementVNode("label", _hoisted_15, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u516C\u544A")), 1), _createElementVNode("article", _hoisted_16, _toDisplayString(_unref(_currentGroup).notification), 1)]), _createVNode(Icon, {
        file: _unref(rightIcon),
        class: "end"
      }, null, 8, ["file"])])]), _createElementVNode("div", _hoisted_17, [_unref(currentSelfRole) === 'Owner' && _unref(groupMemberList).length > 1 ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        class: "list-item",
        onClick: _cache[5] || (_cache[5] = _withModifiers($event => toggleMask('changeOwner'), ["stop"]))
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u8F6C\u8BA9\u7FA4\u7EC4")), 1)) : _createCommentVNode("", true), _unref(canIDissmissGroup) ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "list-item",
        onClick: _cache[6] || (_cache[6] = _withModifiers($event => dismissGroup(_unref(_currentGroup)), ["stop"]))
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u89E3\u6563\u7FA4\u804A")), 1)) : (_openBlock(), _createElementBlock("span", {
        key: 2,
        class: "list-item",
        onClick: _cache[7] || (_cache[7] = _withModifiers($event => quitGroup(_unref(_currentGroup)), ["stop"]))
      }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u9000\u51FA\u7FA4\u7EC4")), 1))])])) : _createCommentVNode("", true), _unref(currentTab) === 'member' ? (_openBlock(), _createBlock(ManageMember, {
        key: 2,
        self: _unref(_currentGroup).selfInfo,
        list: _unref(groupMemberList),
        total: ~~_unref(_currentGroup).memberCount,
        isShowDel: _unref(currentSelfRole) === 'Owner' && _unref(canDelMember),
        onMore: _cache[8] || (_cache[8] = $event => getMember('more')),
        onDel: submit,
        onHandleMemberProfileShow: handleMemberProfileShow,
        onClose: _cache[9] || (_cache[9] = $event => setCurrentTab(''))
      }, null, 8, ["self", "list", "total", "isShowDel"])) : _createCommentVNode("", true), _unref(currentTab) === 'profile' ? (_openBlock(), _createBlock(ManageProfile, {
        key: 3,
        userInfo: _unref(currentMember),
        onClose: _cache[10] || (_cache[10] = $event => setCurrentTab(''))
      }, null, 8, ["userInfo"])) : _createCommentVNode("", true), _unref(currentTab) === 'notification' ? (_openBlock(), _createBlock(ManageNotification, {
        key: 4,
        isAuthor: _unref(isAuthor),
        data: _unref(_currentGroup),
        onUpdate: updateProfile,
        onClose: _cache[11] || (_cache[11] = $event => setCurrentTab(''))
      }, null, 8, ["isAuthor", "data"])) : _createCommentVNode("", true), _unref(currentTab) === 'admin' ? _withDirectives((_openBlock(), _createBlock(ManageAdmin, {
        key: 5,
        isSetMuteTime: _unref(isSetMuteTime),
        member: _unref(member),
        currentGroup: _unref(_currentGroup),
        onAddAdmin: _cache[12] || (_cache[12] = $event => toggleMask('addAdmin')),
        onRemoveAdmin: _cache[13] || (_cache[13] = $event => toggleMask('removeAdmin')),
        onSetAllMuteTime: setAllMuteTime,
        onAddMute: _cache[14] || (_cache[14] = $event => toggleMask('addMute')),
        onRemoveMute: _cache[15] || (_cache[15] = $event => toggleMask('removeMute')),
        onClose: _cache[16] || (_cache[16] = $event => setCurrentTab(''))
      }, null, 8, ["isSetMuteTime", "member", "currentGroup"])), [[_vShow, _unref(isAdmin)]]) : _createCommentVNode("", true), _createVNode(MaskLayer, {
        show: _unref(mask),
        "onUpdate:show": _cache[17] || (_cache[17] = e => mask.value = e)
      }, {
        default: _withCtx(() => [_createVNode(Transfer, {
          title: _unref(TUITranslateService).t("TUIGroup.".concat(_unref(transferTitle))),
          list: _unref(transferList),
          isSearch: _unref(isSearch),
          isRadio: _unref(isRadio),
          selectedList: _unref(selectedList),
          isH5: !_unref(isPC),
          onSubmit: submit,
          onCancel: cancel,
          onSearch: handleSearchMember
        }, null, 8, ["title", "list", "isSearch", "isRadio", "selectedList", "isH5"])]),
        _: 1
      }, 8, ["show"]), _createVNode(Dialog, {
        class: "deleted-dialog",
        title: _unref(TUITranslateService).t("TUIGroup.\u5220\u9664\u6210\u5458"),
        show: _unref(delDialogShow),
        isH5: !_unref(isPC),
        center: true,
        isHeaderShow: _unref(isPC),
        onSubmit: _cache[18] || (_cache[18] = $event => handleManage(_unref(deletedUserList), 'remove')),
        "onUpdate:show": _cache[19] || (_cache[19] = e => delDialogShow.value = e)
      }, {
        default: _withCtx(() => [_unref(deletedUserList).length === 1 ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u786E\u5B9A\u4ECE\u7FA4\u804A\u4E2D\u5220\u9664\u8BE5\u6210\u5458\uFF1F")), 1)) : _createCommentVNode("", true), _unref(deletedUserList).length > 1 ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u786E\u5B9A\u4ECE\u7FA4\u804A\u4E2D\u5220\u9664\u6240\u9009\u6210\u5458\uFF1F")), 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["title", "show", "isH5", "isHeaderShow"])], 512);
    };
  }
});